import 'reflect-metadata';
import {
  Expose,
  Type,
  plainToInstance,
  instanceToPlain,
} from 'class-transformer';

export class MailNotification {
  subject?: string;
  body?: string;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt?: Date;

  @Expose({ name: 'first_name' })
  firstName?: string;

  @Expose({ name: 'last_name' })
  lastName?: string;

  avatar?: any;

  @Expose({ name: 'thread_id' })
  threadId?: number;

  constructor(
    subject?: string,
    body?: string,
    updatedAt?: Date,
    firstName?: string,
    lastName?: string,
    avatar?: any,
    threadId?: number
  ) {
    this.subject = subject;
    this.body = body;
    this.updatedAt = updatedAt;
    this.firstName = firstName;
    this.lastName = lastName;
    this.avatar = avatar;
    this.threadId = threadId;
  }

  static fromJson(json: Record<string, any>): MailNotification {
    return plainToInstance(MailNotification, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
